<template>
  <div class="figures">
    <div class="figures__data">
      <div
        class="figures__row"
        v-for="stat in $t('stats')"
        :key="stat.text">
        <div class="figures__percentage">
          {{ stat.percentage }}
        </div>
        <div
          class="figures__text"
          v-html="stat.text" />
      </div>
    </div>
    <div
      class="figures__more-info"
      v-html="$t('moreInfo') " />
  </div>
</template>

<script>
export default {
  name: "Figures",
  i18n: {
    messages: {
      en: {
        moreInfo: "* Based on internal study using survey data <br/>from general Blinkist customers ",
        stats: [
          {
            percentage: "95%",
            text: "of Blinkist members <b>read significantly more</b> than before*"
          },
          {
            percentage: "91%",
            text: "of Blinkist members <b>create better habits</b>*"
          }, {
            percentage: "87%",
            text: "have made <b>positive changes in their lives</b> thanks to Blinkist*"
          }
        ]
      },
      de: {
        moreInfo: "*Basierend auf einer Umfrage unter </br> Blinkist-Kunden ",
        stats: [
          {
            percentage: "95%",
            text: "der Nutzer<b> lesen</b> mit Blinkist<b /> <b>mehr Bücher</b> als ohne*"
          },
          {
            percentage: "91%",
            text: "<b>verändern</b> mit Blinkist erfolgreich <b>ihre Gewohnheiten</b>*"
          }, {
            percentage: "87%",
            text: "haben dank Blinkist schon einmal <b>positive Veränderungen in ihrem Leben</b> durchgeführt*"
          }
        ]
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.figures {

  &__data {
    padding: $spacing-48 $spacing-16;

    background: $pale-mint-grey;
    @include media(min-width, m) {
      padding: $spacing-48 $spacing-32;
    }
  }

  &__more-info {
    @include font-style(caption);

    padding: $spacing-16;

    text-align: right;
  }

  &__row {
    display: flex;

    &:not(:last-of-type) {
      margin-bottom: $spacing-24;
    }
  }

  &__percentage {
    @include font-style(h3);

    margin-right: $spacing-16;

    color: $blue;
  }

  &__text {
    @include font-style((xs:p1, m: p0));

    flex: 1;
  }
}
</style>
